import { useListClientsQuery, type Client } from '~/api/endpoints/clients'
import { useAppSelector } from '~/app/hooks'
import { selectClientId } from '~/app/clientSlice'
import { DEFAULT_CLIENT_SLUG } from './slug'

/** The switcher's client id, or null for all clients — what every list query is given. */
export function useSelectedClientId(): string | null {
  return useAppSelector(selectClientId)
}

/** Every client by id, for drawing a client's name beside something it owns. */
export function useClientsById(): Map<string, Client> {
  const { data } = useListClientsQuery()
  return new Map((data?.items ?? []).map((listing) => [listing.client.id, listing.client]))
}

/**
 * Where a create dialog's client picker starts: the switcher's client when it is one that
 * takes new work, else the default client, else the first active one.
 */
export function useNewWorkClientId(): string | null {
  const selected = useSelectedClientId()
  const { data } = useListClientsQuery()
  const active = (data?.items ?? [])
    .map((listing) => listing.client)
    .filter((client) => client.status === 'active')
  if (selected && active.some((client) => client.id === selected)) return selected
  return (
    active.find((client) => client.slug === DEFAULT_CLIENT_SLUG)?.id ?? active[0]?.id ?? null
  )
}
